// src/pages/equipmentrentaladmin/equipment/MyEquipment.jsx

import React, { useState, useEffect, useContext } from "react";
import { FaPlus } from "react-icons/fa";
import { MdInventory, MdCheckCircle } from "react-icons/md";
import {
  FiMoreVertical,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiX,
  FiPackage,
  FiDollarSign,
  FiTag,
  FiInfo,
  FiRefreshCw,
  FiBriefcase,
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import RentalAdminLayout from "../../../layout/equipmentrentaladmin/RentalAdminLayout.js";
import AppContext from "../../../context/AppContext.js";
import axios from "axios";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import Swal from "sweetalert2";
import "../../../assets/css/equipmentrentaladmin/myequipment/MyEquipment.css";

const MyEquipment = () => {
  const { baseUrl, baseUrlForFile, loggedInRental, authToken } = useContext(AppContext);
  const navigate = useNavigate();

  const [equipmentname, setEquipmentName] = useState("");
  const [category_id, setCategory_id] = useState("");
  const [ratePerHour, setRatePerHour] = useState("");
  const [ratePerDay, setRatePerDay] = useState("");
  const [ratePerAcre, setRatePerAcre] = useState("");
  const [status, setStatus] = useState("");
  const [specification, setSpecification] = useState([]);
  const [about, setAbout] = useState("");
  const [image, setImage] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [idToUpdateDeleteEquipment, setIdToUpdateDeleteEquipment] = useState("");
  const [equipmentImagePreview, setEquipmentImagePreview] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenu, setActiveMenu] = useState(null);
  const [equipmentData, setEquipmentData] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [categories, setCategories] = useState([]);

  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [statusTargetEquipment, setStatusTargetEquipment] = useState(null);
  const [newStatus, setNewStatus] = useState("");

  const editFileRef = React.useRef(null);

  const total = equipmentData.length;
  const available = equipmentData.filter((e) => e.status === "available").length;
  const rented = equipmentData.filter((e) => e.status === "rented").length;

  const itemsPerPage = 5;
  const totalPages = Math.ceil(equipmentData.length / itemsPerPage);
  const paginatedData = equipmentData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(".meq-actions-wrapper")) setActiveMenu(null);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  useEffect(() => {
    viewAllEquipments();
    fetchAllCategories();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setEquipmentImagePreview(URL.createObjectURL(file));
    }
  };

  const addTag = () => {
    if (newTag.trim() && !specification.includes(newTag.trim())) {
      setSpecification([...specification, newTag.trim()]);
      setNewTag("");
    }
  };
  const removeTag = (t) => setSpecification(specification.filter((x) => x !== t));
  const getImageUrl = (img) => (img ? `${baseUrlForFile}/${img}` : null);

  // ── Helper: business name / address from nested relation ──
  const getShopName = (item) =>
    item.shop_name || item.srrentaladmin?.srbusinessdetails?.businessname || "—";
  const getShopAddress = (item) =>
    item.shop_address || item.srrentaladmin?.srbusinessdetails?.address || "—";

  const viewAllEquipments = () => {
    if (!loggedInRental) return;
    axios
      .post(`${baseUrl}/rentaladmin/equipmentmanagement/viewallequipments`, {
        srrentaladmin_id: loggedInRental.id,
      }, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success && response.data.data) {
          setEquipmentData(response.data.data);
        } else {
          setEquipmentData([]);
        }
      })
      .catch(() => setEquipmentData([]));
  };

  const fetchAllCategories = () => {
    axios
      .get(`${baseUrl}/rentaladmin/category/fetchAllCategories`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success == true) {
          setCategories(response.data.categories);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateEquipment = () => {
    const formdata = new FormData();
    formdata.append("id", idToUpdateDeleteEquipment);
    formdata.append("equipmentname", equipmentname);
    formdata.append("category_id", category_id);
    formdata.append("rate_per_hour", ratePerHour || "");
    formdata.append("rate_per_day", ratePerDay || "");
    formdata.append("rate_per_acre", ratePerAcre || "");
    formdata.append("status", status);
    formdata.append("specification", specification.join(","));
    formdata.append("about", about);
    if (image) formdata.append("image", image);
    axios
      .post(
        `${baseUrl}/rentaladmin/equipmentmanagement/updateequipment`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        viewAllEquipments();
        resetForm();
        setShowEdit(false);
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Equipment details have been updated successfully.",
          confirmButtonColor: "#FDB714",
          timer: 2000,
          timerProgressBar: true,
        });
      })
      .catch((e) => {
        console.log(e);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Something went wrong while updating the equipment.",
          confirmButtonColor: "#FDB714",
        });
      });
  };

  const cancelEdit = () => {
    setShowEdit(false);
    resetForm();
    Swal.fire({
      icon: "info",
      title: "Cancelled",
      text: "Your changes were discarded.",
      confirmButtonColor: "#FDB714",
      timer: 1500,
      timerProgressBar: true,
    });
  };

  const deleteEquipment = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This equipment will be permanently deleted.",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (!result.isConfirmed) return;
      const formData = new FormData();
      formData.append("id", id);
      axios
        .post(
          `${baseUrl}/rentaladmin/equipmentmanagement/deleteequipment`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`
            },
          },
        )
        .then((response) => {
          console.log(response);
          viewAllEquipments();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Equipment has been deleted successfully.",
            confirmButtonColor: "#FDB714",
            timer: 2000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            icon: "error",
            title: "Delete Failed",
            text: "Something went wrong while deleting the equipment.",
            confirmButtonColor: "#FDB714",
          });
        });
    });
  };

  const editEquipment = (equip) => {
    setIsEditing(true);
    setIdToUpdateDeleteEquipment(equip.id);
    setEquipmentName(equip.equipmentname);
    setCategory_id(equip.category_id);
    setRatePerHour(equip.rate_per_hour ?? "");
    setRatePerDay(equip.rate_per_day ?? "");
    setRatePerAcre(equip.rate_per_acre ?? "");
    setStatus(equip.status);
    setAbout(equip.about);
    setSpecification(
      equip.specification ? equip.specification.split(",").filter(Boolean) : [],
    );
    setEquipmentImagePreview(equip.image ? getImageUrl(equip.image) : null);
    setImage(null);
    setActiveMenu(null);
    setShowEdit(true);
  };

  const resetForm = () => {
    setIsEditing(false);
    setIdToUpdateDeleteEquipment("");
    setEquipmentName("");
    setCategory_id("");
    setRatePerHour("");
    setRatePerDay("");
    setRatePerAcre("");
    setSpecification([]);
    setStatus("");
    setAbout("");
    setImage(null);
    setEquipmentImagePreview(null);
    setNewTag("");
  };

  const getStatusClass = (s) => {
    if (s === "available") return "meq-badge-available";
    if (s === "rented") return "meq-badge-rented";
    if (s === "maintenance") return "meq-badge-maintenance";
    return "meq-badge-available";
  };

  const openUpdateStatus = (equip) => {
    setStatusTargetEquipment(equip);
    setNewStatus(equip.status || "available");
    setActiveMenu(null);
    setShowUpdateStatus(true);
  };

  const closeUpdateStatus = () => {
    setShowUpdateStatus(false);
    setStatusTargetEquipment(null);
    setNewStatus("");
    Swal.fire({
      icon: "info",
      title: "Cancelled",
      text: "Status change was discarded.",
      confirmButtonColor: "#FDB714",
      timer: 1500,
      timerProgressBar: true,
    });
  };

  const confirmUpdateStatus = () => {
    if (!statusTargetEquipment) return;
    const formdata = new FormData();
    formdata.append("id", statusTargetEquipment.id);
    formdata.append("equipmentname", statusTargetEquipment.equipmentname);
    formdata.append("category_id", statusTargetEquipment.category_id);
    formdata.append("rate_per_hour", statusTargetEquipment.rate_per_hour ?? "");
    formdata.append("rate_per_day", statusTargetEquipment.rate_per_day ?? "");
    formdata.append("rate_per_acre", statusTargetEquipment.rate_per_acre ?? "");
    formdata.append("status", newStatus);
    formdata.append("specification", statusTargetEquipment.specification || "");
    formdata.append("about", statusTargetEquipment.about || "");
    axios
      .post(
        `${baseUrl}/rentaladmin/equipmentmanagement/updateequipment`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        viewAllEquipments();
        setShowUpdateStatus(false);
        setStatusTargetEquipment(null);
        setNewStatus("");
        Swal.fire({
          icon: "success",
          title: "Status Updated!",
          text: "Equipment status has been changed successfully.",
          confirmButtonColor: "#FDB714",
          timer: 2000,
          timerProgressBar: true,
        });
      })
      .catch((e) => {
        console.log(e);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Something went wrong while updating the status.",
          confirmButtonColor: "#FDB714",
        });
      });
  };

  const renderPricing = (item) => {
    const parts = [];
    if (item.rate_per_hour) parts.push(`Rs ${Number(item.rate_per_hour).toLocaleString()}/hr`);
    if (item.rate_per_day) parts.push(`Rs ${Number(item.rate_per_day).toLocaleString()}/day`);
    if (item.rate_per_acre) parts.push(`Rs ${Number(item.rate_per_acre).toLocaleString()}/acre`);
    return parts.length ? parts.join(" • ") : "—";
  };

  return (
    <RentalAdminLayout>
      <div className="meq-page">
        <Row className="mb-3">
          {[
            { icon: <MdInventory />, value: total, label: "Total Equipment", cls: "" },
            { icon: <MdCheckCircle />, value: available, label: "Available", cls: "success" },
            { icon: <FaRupeeSign />, value: rented, label: "Currently Rented", cls: "warning" }
          ].map((s, i) => (
            <Col md={4} key={i}>
              <div className={`my-stat-card ${s.cls}`}>
                <span className="my-stat-icon">{s.icon}</span>
                <h3>{s.value}</h3>
                <p>{s.label}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="meq-table-section">
          <div className="meq-section-header">
            <h2 className="meq-section-title">All Equipments Management</h2>
            <button
              className="meq-add-btn"
              onClick={() => navigate("/rental-admin/addequipment")}
            >
              <FaPlus size={14} /> Add New Equipment
            </button>
          </div>

          <div className="meq-table-wrapper">
            <table className="meq-table">
              <thead>
                <tr>
                  <th>IMAGE</th>
                  <th>EQUIPMENT NAME</th>
                  <th>CATEGORY</th>
                  <th>SHOP NAME</th>
                  <th>PRICING</th>
                  <th>STATUS</th>
                  <th className="meq-col-action">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item) => (
                    <tr key={item.id}>
                      <td>
                        {getImageUrl(item.image) ? (
                          <img
                            src={getImageUrl(item.image)}
                            alt={item.equipmentname}
                            className="meq-table-img"
                          />
                        ) : (
                          <div className="meq-table-img-placeholder">
                            <MdInventory />
                          </div>
                        )}
                      </td>
                      <td className="meq-equipment-name">{item.equipmentname}</td>
                      <td>{item.category?.name}</td>
                      <td>{getShopName(item)}</td>
                      <td>
                        <span className="meq-price" style={{ fontSize: "12px" }}>
                          {renderPricing(item)}
                        </span>
                      </td>
                      <td>
                        <span className={`meq-status-badge ${getStatusClass(item.status)}`}>
                          <span className="meq-badge-dot"></span>
                          {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "—"}
                        </span>
                      </td>
                      <td className="meq-col-action">
                        <div className="meq-actions-wrapper">
                          <button
                            className="meq-dots-btn"
                            onClick={() => setActiveMenu(activeMenu === item.id ? null : item.id)}
                          >
                            <FiMoreVertical size={17} />
                          </button>
                          {activeMenu === item.id && (
                            <div className="meq-dropdown-menu">
                              <button
                                className="meq-dropdown-item"
                                onClick={() => {
                                  setSelectedEquipment(item);
                                  setShowView(true);
                                  setActiveMenu(null);
                                }}
                              >
                                <FiEye size={14} className="meq-item-view" /> View Detail
                              </button>
                              <div className="meq-dropdown-divider" />
                              <button
                                className="meq-dropdown-item"
                                onClick={() => {
                                  editEquipment(item);
                                  setActiveMenu(null);
                                  Swal.fire({
                                    toast: true,
                                    position: "top-end",
                                    icon: "info",
                                    title: "Editing equipment...",
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                  });
                                }}
                              >
                                <FiEdit2 size={14} className="meq-item-edit" /> Edit
                              </button>
                              <button
                                className="meq-dropdown-item"
                                onClick={() => openUpdateStatus(item)}
                              >
                                <FiRefreshCw size={14} className="meq-item-status" /> Update Status
                              </button>
                              <div className="meq-dropdown-divider" />
                              <button
                                className="meq-dropdown-item meq-item-del"
                                onClick={() => {
                                  deleteEquipment(item.id);
                                  setActiveMenu(null);
                                }}
                              >
                                <FiTrash2 size={14} /> Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="meq-empty-row">No equipment found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <AppPagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={equipmentData.length}
            itemsPerPage={itemsPerPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>

        {/* ── VIEW DETAIL MODAL ── */}
        {showView && selectedEquipment && (
          <div className="meq-modal-overlay" onClick={() => setShowView(false)}>
            <div className="meq-modal-box meq-modal-lg" onClick={(e) => e.stopPropagation()}>
              <div className="meq-modal-header-dark">
                <div>
                  <h5 className="meq-modal-header-title">Equipment Detail</h5>
                  <span className="meq-modal-header-sub">Full breakdown of this equipment</span>
                </div>
                <button className="meq-modal-close-circle" onClick={() => setShowView(false)}>
                  <FiX />
                </button>
              </div>

              <div className="meq-modal-body">
                <div className="meq-modal-status-bar">
                  <div className="meq-sb-left">
                    <span className="meq-sb-id">
                      #{selectedEquipment.id} — {selectedEquipment.equipmentname}
                    </span>
                    <span className={`meq-status-badge ${getStatusClass(selectedEquipment.status)}`}>
                      <span className="meq-badge-dot"></span>
                      {selectedEquipment.status
                        ? selectedEquipment.status.charAt(0).toUpperCase() + selectedEquipment.status.slice(1)
                        : "—"}
                    </span>
                  </div>
                  <span className="meq-sb-date">{selectedEquipment.category_id}</span>
                </div>

                {getImageUrl(selectedEquipment.image) && (
                  <img
                    src={getImageUrl(selectedEquipment.image)}
                    alt={selectedEquipment.equipmentname}
                    className="meq-detail-img"
                  />
                )}

                <p className="meq-section-label"><FiPackage size={14} /> Equipment Information</p>
                <div className="meq-info-grid">
                  <div className="meq-info-item">
                    <label>Equipment Name</label>
                    <span>{selectedEquipment.equipmentname}</span>
                  </div>
                  <div className="meq-info-item">
                    <label>Category</label>
                    <span>{selectedEquipment.category?.name || selectedEquipment.category_id}</span>
                  </div>
                  <div className="meq-info-item">
                    <label>Status</label>
                    <span className={`meq-status-badge ${getStatusClass(selectedEquipment.status)}`}>
                      <span className="meq-badge-dot"></span>
                      {selectedEquipment.status
                        ? selectedEquipment.status.charAt(0).toUpperCase() + selectedEquipment.status.slice(1)
                        : "—"}
                    </span>
                  </div>
                </div>

                <p className="meq-section-label"><FiBriefcase size={14} /> Shop Information</p>
                <div className="meq-info-grid">
                  <div className="meq-info-item">
                    <label>Shop Name</label>
                    <span>{getShopName(selectedEquipment)}</span>
                  </div>
                  <div className="meq-info-item">
                    <label>Address</label>
                    <span>{getShopAddress(selectedEquipment)}</span>
                  </div>
                </div>

                <p className="meq-section-label"><FiDollarSign size={14} /> Pricing</p>
                <div className="meq-financials-box">
                  {selectedEquipment.rate_per_hour && (
                    <div className="meq-fin-row">
                      <span>Rate /Hour</span>
                      <span className="meq-fin-pos">
                        Rs {Number(selectedEquipment.rate_per_hour).toLocaleString()}
                      </span>
                    </div>
                  )}
                  {selectedEquipment.rate_per_day && (
                    <div className="meq-fin-row">
                      <span>Rate /Day</span>
                      <span className="meq-fin-pos">
                        Rs {Number(selectedEquipment.rate_per_day).toLocaleString()}
                      </span>
                    </div>
                  )}
                  {selectedEquipment.rate_per_acre && (
                    <div className="meq-fin-row">
                      <span>Rate /Acre</span>
                      <span className="meq-fin-pos">
                        Rs {Number(selectedEquipment.rate_per_acre).toLocaleString()}
                      </span>
                    </div>
                  )}
                </div>

                {selectedEquipment.specification && (
                  <>
                    <p className="meq-section-label"><FiTag size={14} /> Specification Tags</p>
                    <div className="meq-tags-row">
                      {selectedEquipment.specification.split(",").filter(Boolean).map((tag, i) => (
                        <span key={i} className="meq-tag-chip">{tag}</span>
                      ))}
                    </div>
                  </>
                )}

                {selectedEquipment.about && (
                  <div className="meq-notes-box">
                    <FiInfo size={14} color="#FDB714" style={{ marginTop: 2, flexShrink: 0 }} />
                    <span><strong>About: </strong>{selectedEquipment.about}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── EDIT MODAL ── */}
        {showEdit && (
          <div className="meq-modal-overlay" onClick={() => { setShowEdit(false); resetForm(); }}>
            <div className="meq-modal-box meq-modal-lg" onClick={(e) => e.stopPropagation()}>
              <div className="meq-modal-header-dark">
                <div>
                  <h5 className="meq-modal-header-title">Edit Equipment</h5>
                  <span className="meq-modal-header-sub">Update equipment details</span>
                </div>
                <button className="meq-modal-close-circle" onClick={() => { setShowEdit(false); resetForm(); }}>
                  <FiX />
                </button>
              </div>

              <div className="meq-modal-body">
                <div className="meq-form-grid">
                  <div className="meq-upload-section">
                    <label className="meq-form-label">Equipment Picture</label>
                    <div className="meq-upload-box" onClick={() => editFileRef.current.click()}>
                      {equipmentImagePreview ? (
                        <img src={equipmentImagePreview} alt="Preview" className="meq-preview-img" />
                      ) : (
                        <span className="meq-upload-placeholder">CHANGE PHOTO</span>
                      )}
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={editFileRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <button className="meq-choose-btn" onClick={() => editFileRef.current.click()}>
                      Choose File
                    </button>
                  </div>

                  <div className="meq-form-fields">
                    <div className="meq-field-row">
                      <div className="meq-field-group">
                        <label className="meq-form-label">Equipment Name *</label>
                        <input
                          className="meq-input"
                          type="text"
                          value={equipmentname}
                          onChange={(e) => setEquipmentName(e.target.value)}
                        />
                      </div>
                      <div className="meq-field-group">
                        <label className="meq-form-label">Category *</label>
                        <select
                          className="meq-input"
                          value={category_id}
                          onChange={(e) => setCategory_id(e.target.value)}
                        >
                          <option value="">Select Category</option>
                          {categories.map((cat) => (
                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="meq-field-row">
                      <div className="meq-field-group">
                        <label className="meq-form-label">Rate /Hour (Rs)</label>
                        <input
                          className="meq-input"
                          type="number"
                          value={ratePerHour}
                          onChange={(e) => setRatePerHour(e.target.value)}
                        />
                      </div>
                      <div className="meq-field-group">
                        <label className="meq-form-label">Rate /Day (Rs)</label>
                        <input
                          className="meq-input"
                          type="number"
                          value={ratePerDay}
                          onChange={(e) => setRatePerDay(e.target.value)}
                        />
                      </div>
                      <div className="meq-field-group">
                        <label className="meq-form-label">Rate /Acre (Rs)</label>
                        <input
                          className="meq-input"
                          type="number"
                          value={ratePerAcre}
                          onChange={(e) => setRatePerAcre(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="meq-field-group meq-full-width">
                      <label className="meq-form-label">About</label>
                      <textarea
                        className="meq-input meq-textarea"
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <p className="meq-section-label"><FiTag size={14} /> Specification Tags</p>
                <div className="meq-tag-input-row">
                  <input
                    className="meq-input"
                    type="text"
                    placeholder="Add tag..."
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && addTag()}
                  />
                  <button className="meq-add-tag-btn" onClick={addTag}><FaPlus /></button>
                </div>
                <div className="meq-tags-row">
                  {Array.isArray(specification) && specification.map((tag, i) => (
                    <span key={i} className="meq-tag-chip">
                      {tag} <span className="meq-tag-remove" onClick={() => removeTag(tag)}>×</span>
                    </span>
                  ))}
                </div>

                <div className="meq-form-buttons">
                  <button className="meq-cancel-btn" onClick={cancelEdit}>Cancel</button>
                  <button className="meq-confirm-btn" onClick={updateEquipment}>Update Equipment</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── UPDATE STATUS MODAL ── */}
        {showUpdateStatus && statusTargetEquipment && (
          <div className="meq-modal-overlay" onClick={closeUpdateStatus}>
            <div className="meq-modal-box meq-modal-sm" onClick={(e) => e.stopPropagation()}>
              <div className="meq-modal-header-dark">
                <div>
                  <h5 className="meq-modal-header-title">Update Status</h5>
                  <span className="meq-modal-header-sub">{statusTargetEquipment.equipmentname}</span>
                </div>
                <button className="meq-modal-close-circle" onClick={closeUpdateStatus}>
                  <FiX />
                </button>
              </div>

              <div className="meq-modal-body">
                <div className="meq-field-group meq-full-width">
                  <label className="meq-form-label">Status *</label>
                  <select
                    className="meq-input"
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                  >
                    <option value="available">Available</option>
                    <option value="rented">Rented</option>
                  </select>
                </div>

                <div className="meq-form-buttons">
                  <button className="meq-cancel-btn" onClick={closeUpdateStatus}>Cancel</button>
                  <button className="meq-confirm-btn" onClick={confirmUpdateStatus}>Update Status</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </RentalAdminLayout>
  );
};

export default MyEquipment;